import _extends from 'babel-runtime/helpers/extends';
export default {
  name: 'VirtualList',
  props: {
    size: {
      type: Number,
      required: true
    },
    remain: {
      type: Number,
      required: true
    },
    rtag: {
      type: String,
      'default': 'div'
    },
    wtag: {
      type: String,
      'default': 'div'
    },
    wtagProps: {
      type: Object,
      'default': null
    },
    externalScrolling: {
      type: Boolean,
      'default': false
    },
    theme: {
      type: String,
      'default': 'default'
    },
    maxHeight: Number,
    wclass: {
      type: String,
      'default': ''
    },
    pagemode: {
      type: Boolean,
      'default': false
    },
    start: {
      type: Number,
      'default': 0
    },
    offset: {
      type: Number,
      'default': 0
    },
    variable: {
      type: [Function, Boolean],
      'default': false
    },
    bench: {
      type: Number,
      'default': 0 // 预留多少节点
    },
    debounce: {
      type: Number,
      'default': 0
    },
    totop: {
      type: [Function, Boolean], // 自定义事件.
      'default': false
    },
    tobottom: {
      type: [Function, Boolean], // 自定义事件.
      'default': false
    },
    onscroll: {
      type: [Function, Boolean], // 自定义事件.
      'default': false
    },
    item: {
      type: String,
      'default': null
    },
    itemcount: {
      type: Number,
      'default': 0
    },
    itemprops: {
      type: Function,
      'default': function _default() {}
    },
    target: {
      type: HTMLDivElement,
      'default': null
    },
    paddingTop: {
      type: Number,
      'default': 0
    },
    paddingBottom: {
      type: Number,
      'default': 0
    }
  },

  watch: {
    size: function size() {
      this.changeProp = 'size';
    },
    remain: function remain() {
      this.changeProp = 'remain';
    },
    bench: function bench() {
      this.changeProp = 'bench';
      this.itemModeForceRender();
    },
    start: function start() {
      this.changeProp = 'start';
      this.itemModeForceRender();
    },
    offset: function offset() {
      this.changeProp = 'offset';
      this.itemModeForceRender();
    },
    itemcount: function itemcount() {
      this.changeProp = 'itemcount';
      this.itemModeForceRender();
    }
  },

  created: function created() {
    var start = this.start >= this.remain ? this.start : 0;
    var keeps = this.remain + (this.bench || this.remain);

    var delta = Object.create(null);

    delta.direction = ''; // 当前滚动方向, D: down, U: up.
    delta.scrollTop = 0; // 当前滚动顶部，用于指示方向.
    delta.start = start; // 开始索引.
    delta.end = start + keeps - 1; // 结束索引.
    delta.keeps = keeps; // nums 保持真正的 dom 数量.
    delta.total = 0; // 所有项目总数，在过滤器中更新.
    delta.offsetAll = 0; // 缓存所有可滚动的偏移量.
    delta.paddingTop = this.paddingTop; // 容器包装真正的填充顶部间距.
    delta.paddingBottom = this.paddingBottom; // 容器包装真正的填充底部间距.
    delta.varCache = {}; // 对象缓存变量索引高度和滚动偏移量.
    delta.varAverSize = 0; // 计算项目的高度.
    delta.varLastCalcIndex = 0; // 最后计算的变量高度/偏移量指数.

    this.delta = delta;
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      if (_this.pagemode && _this.target) {
        _this.target.addEventListener('scroll', _this.onScroll, false);
      }
    });

    if (this.start) {
      var start = this.getZone(this.start).start;
      this.setScrollTop(this.variable ? this.getVarOffset(start) : start * this.size);
    } else if (this.offset) {
      this.setScrollTop(this.offset);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.pagemode && this.target) {
      this.target.removeEventListener('scroll', this.onScroll, false);
    }
  },


  // 检查 props 更改时是否应更新 delta.
  beforeUpdate: function beforeUpdate() {
    var delta = this.delta;
    delta.keeps = this.remain + (this.bench || this.remain);

    var calcstart = this.changeProp === 'start' ? this.start : delta.start;

    if (this.$slots['default']) {
      delta.total = this.$slots['default'].length;
    }

    var zone = this.getZone(calcstart);

    // 当 start, size or offset 变化, 更新滚动位置.
    if (this.changeProp && ['start', 'size', 'offset'].includes(this.changeProp)) {
      var scrollTop = this.changeProp === 'offset' ? this.offset : this.variable ? this.getVarOffset(zone.isLast ? delta.total : zone.start) : zone.isLast && delta.total - calcstart <= this.remain ? delta.total * this.size : calcstart * this.size;

      this.$nextTick(this.setScrollTop.bind(this, scrollTop));
    }

    // 如果有差异，再次强制更新.
    if (this.changeProp || delta.end !== zone.end || calcstart !== zone.start) {
      this.changeProp = '';
      delta.end = zone.end;
      delta.start = zone.start;
      this.forceRender();
    }
  },
  updated: function updated() {
    this.setScrollTop(this.delta.scrollTop);
  },


  methods: {
    onScroll: function onScroll(event) {
      var delta = this.delta;
      var vsl = this.$refs.vsl;
      var offset = this.pagemode ? this.target.scrollTop : (this.externalScrolling ? vsl.$refs.wrap : vsl.$el || vsl).scrollTop || 0;

      delta.direction = offset > delta.scrollTop ? 'D' : 'U';
      delta.scrollTop = offset;

      if (delta.total > delta.keeps) {
        // 传递事件给外部
        this.$emit('updateBefore', event);
        this.updateZone(offset);
      } else {
        delta.end = delta.total - 1;
      }

      var offsetAll = delta.offsetAll;
      if (this.onscroll) {
        var param = Object.create(null);
        param.offset = offset;
        param.offsetAll = offsetAll;
        param.start = delta.start;
        param.end = delta.end;
        this.onscroll(event, param);
      }

      if (!offset && delta.total) {
        this.fireEvent('totop');
      }

      if (offset >= offsetAll) {
        this.fireEvent('tobottom');
      }
    },


    // 通过滚动偏移更新渲染区域.
    updateZone: function updateZone(offset) {
      var delta = this.delta;
      var overs = this.variable ? this.getVarOvers(offset) : Math.floor(offset / this.size);

      // 如果向上滚动，减少偏移.
      if (delta.direction === 'U') {
        overs = overs - this.remain + 1;
      }

      var zone = this.getZone(overs);
      var bench = this.bench || this.remain;

      // 为了获得更好的性能，如果在现在的工作台中滚动传递项目，请不要更新.
      // 如果要到达最后一个项目，我们应该立即渲染下一个区域.
      var shouldRenderNextZone = Math.abs(overs - delta.start - bench) === 1;

      if (!shouldRenderNextZone && overs - delta.start <= bench && !zone.isLast && overs > delta.start) {
        return;
      }

      // 尽量减少这个方法调用.
      if (shouldRenderNextZone || zone.start !== delta.start || zone.end !== delta.end) {
        delta.end = zone.end;
        delta.start = zone.start;
        this.forceRender();
      }
    },


    // 通过 start / index 返回正确的区域信息.
    getZone: function getZone(index) {
      var start = void 0,
          end = void 0;
      var delta = this.delta;

      index = parseInt(index, 10);
      index = Math.max(0, index);

      var lastStart = delta.total - delta.keeps;
      var isLast = index <= delta.total && index >= lastStart || index > delta.total;

      if (isLast) {
        end = delta.total - 1;
        start = Math.max(0, lastStart);
      } else {
        start = index;
        end = start + delta.keeps - 1;
      }

      return {
        end: end,
        start: start,
        isLast: isLast
      };
    },


    // 公共方法，如果需要，强制渲染 ui 列表.
    // 在下一次重绘之前调用它以获得更好的性能.
    forceRender: function forceRender() {
      var _this2 = this;

      window.requestAnimationFrame(function () {
        _this2.$forceUpdate();

        _this2.$nextTick(function () {
          _this2.$emit('updateAfter', event);
        });
      });
    },
    itemModeForceRender: function itemModeForceRender() {
      if (this.item) {
        this.forceRender();
      }
    },


    // 返回滚动的项目条数.
    getVarOvers: function getVarOvers(offset) {
      var low = 0;
      var middle = 0;
      var middleOffset = 0;
      var delta = this.delta;
      var high = delta.total;

      // 使用二分搜索，提高效率
      while (low <= high) {
        middle = low + Math.floor((high - low) / 2);
        middleOffset = this.getVarOffset(middle);

        // 计算第一次二分搜索时的平均变量高度.
        if (!delta.varAverSize) {
          delta.varAverSize = Math.floor(middleOffset / middle);
        }

        if (middleOffset === offset) {
          return middle;
        } else if (middleOffset < offset) {
          low = middle + 1;
        } else if (middleOffset > offset) {
          high = middle - 1;
        }
      }

      return low > 0 ? --low : 0;
    },


    // 从给定索引返回变量滚动偏移量.
    getVarOffset: function getVarOffset(index, nocache) {
      var delta = this.delta;
      var cache = delta.varCache[index];

      if (!nocache && cache) {
        return cache.offset;
      }

      var offset = 0;
      for (var i = 0; i < index; i++) {
        var size = this.getVarSize(i, nocache);
        delta.varCache[i] = {
          size: size,
          offset: offset
        };
        offset += size;
      }

      delta.varLastCalcIndex = Math.max(delta.varLastCalcIndex, index - 1);
      delta.varLastCalcIndex = Math.min(delta.varLastCalcIndex, delta.total - 1);

      return offset;
    },


    // 从给定索引返回可变大小（高度）.
    getVarSize: function getVarSize(index, nocache) {
      var cache = this.delta.varCache[index];
      if (!nocache && cache) {
        return cache.size;
      }

      if (typeof this.variable === 'function') {
        return this.variable(index) || 0;
      } else {
        // 使用 item 时，它只能获得当前组件的高度,
        // 后续优化，或考虑使用变量函数
        var slot = this.item ? this.$children[index] ? this.$children[index].$vnode : null : this.$slots['default'][index];

        var style = slot && slot.data && slot.data.style;
        if (style && style.height) {
          var shm = style.height.match(/^(.*)px$/);
          return shm && +shm[1] || 0;
        }
      }
      return 0;
    },


    // 返回变量 paddingTop .
    getVarPaddingTop: function getVarPaddingTop() {
      return this.getVarOffset(this.delta.start);
    },


    // 返回变量 paddingBottom.
    getVarPaddingBottom: function getVarPaddingBottom() {
      var delta = this.delta;
      var last = delta.total - 1;
      if (delta.total - delta.end <= delta.keeps || delta.varLastCalcIndex === last) {
        return this.getVarOffset(last) - this.getVarOffset(delta.end);
      } else {
        // 如果未到达最后一个区域或未计算真实的偏移量
        // 返回估计值 paddingBottom ，避免计算太多.
        return (delta.total - delta.end) * (delta.varAverSize || this.size);
      }
    },


    // 返回总高度用来判断是否到底部.
    getVarAllHeight: function getVarAllHeight() {
      var delta = this.delta;
      if (delta.total - delta.end <= delta.keeps || delta.varLastCalcIndex === delta.total - 1) {
        return this.getVarOffset(delta.total);
      } else {
        return this.getVarOffset(delta.start) + (delta.total - delta.end) * (delta.varAverSize || this.size);
      }
    },


    // 公共方法，允许通过索引更新变量.
    updateVariable: function updateVariable(index) {
      // 清除/更新索引前的所有偏移和高度.
      this.getVarOffset(index, true);
    },


    // 触发事件.
    fireEvent: function fireEvent(event) {
      if (this[event]) {
        this[event]();
      }
    },


    // 手动设置滚动顶部.
    setScrollTop: function setScrollTop(scrollTop) {
      if (this.pagemode) {
        this.target.scrollTop = scrollTop;
      } else {
        var vsl = this.$refs.vsl;
        if (vsl) {
          (this.externalScrolling ? vsl.$refs.wrap : vsl.$el || vsl).scrollTop = scrollTop;
        }
      }
    },


    // 根据 `start` 和 `end` 过滤显示的项目.
    filter: function filter(h) {
      var delta = this.delta;
      var slots = this.$slots['default'] || [];

      if (this.item) {
        delta.total = this.itemcount;
        if (delta.keeps > delta.total) {
          delta.end = delta.total - 1;
        }
      } else {
        if (!slots.length) {
          delta.start = 0;
        }
        delta.total = slots.length;
      }

      var paddingTop = void 0,
          paddingBottom = void 0,
          allHeight = void 0;
      var hasPadding = delta.total > delta.keeps;

      if (this.variable) {
        allHeight = this.getVarAllHeight();
        paddingTop = hasPadding ? this.getVarPaddingTop() : 0;
        paddingBottom = hasPadding ? this.getVarPaddingBottom() : 0;
      } else {
        allHeight = this.size * delta.total;
        paddingTop = this.size * (hasPadding ? delta.start : 0);
        paddingBottom = this.size * (hasPadding ? delta.total - delta.keeps : 0) - paddingTop;
      }

      if (paddingBottom < this.size) {
        paddingBottom = 0;
      }
      // if (this.pagemode && this.$el && this.$el.parentElement) {
      //   let bodyRect = document.body.getBoundingClientRect()
      //   let elemRect = this.$el.parentElement.getBoundingClientRect()
      //   let offset = elemRect.top - bodyRect.top
      //   paddingTop -= offset
      //   if (paddingTop < 0) paddingTop = 0
      // }
      delta.paddingTop = paddingTop;
      delta.paddingBottom = paddingBottom;
      delta.offsetAll = allHeight - this.size * this.remain;

      this.$emit('update:paddingTop', paddingTop);
      this.$emit('update:paddingBottom', paddingBottom);

      var renders = [];
      for (var i = delta.start; i < delta.total && i <= Math.ceil(delta.end); i++) {
        var slot = null;
        if (this.item) {
          slot = h(this.item, this.itemprops(i));
        } else {
          slot = slots[i];
        }

        renders.push(slot);
      }

      return renders;
    }
  },

  render: function render(h) {
    var list = this.filter(h);
    var _delta = this.delta,
        paddingTop = _delta.paddingTop,
        paddingBottom = _delta.paddingBottom;


    var renderList = h(this.wtag, {
      props: _extends({}, this.wtagProps),
      style: {
        'padding-top': paddingTop + 'px',
        'padding-bottom': paddingBottom + 'px'
      },
      'class': this.wclass,
      attrs: {
        role: 'virtual'
      }
    }, list);

    if (this.pagemode) {
      return renderList;
    }

    return h(this.rtag, {
      props: {
        theme: this.theme,
        maxHeight: this.maxHeight
      },
      ref: 'vsl',
      style: {
        display: 'block',
        'overflow-y': 'auto',
        height: !this.externalScrolling ? this.size * this.remain + 'px' : null
      },
      on: {
        '&scroll': this.onScroll
      }
    }, [renderList]);
  }
};